import Products from './component';

export default Products;
